export type StageStatus = 'completed' | 'active' | 'planned';
export type StageMediaType = 'photo' | 'video';

export type StageMediaItem = {
  id: string;
  title: string;
  type: StageMediaType;
  description: string;
  src: string;
  thumbnail: string;
};

export type ProjectStage = {
  id: string;
  name: string;
  shortName: string;
  period: string;
  status: StageStatus;
  description: string;
  deliverables: string[];
  media: StageMediaItem[];
};

export const projectStages: ProjectStage[] = [
  {
    id: 'stage-1',
    name: 'Etapa 1: Infraestructura Base',
    shortName: 'Etapa 1',
    period: 'Q3 2026',
    status: 'active',
    description: '',
    deliverables: [],
    media: [],
  },
  {
    id: 'stage-2',
    name: 'Etapa 2: Expansion Operativa',
    shortName: 'Etapa 2',
    period: 'Q1 2027',
    status: 'planned',
    description: '',
    deliverables: [],
    media: [],
  },
  {
    id: 'stage-3',
    name: 'Etapa 3: Consolidacion Regional',
    shortName: 'Etapa 3',
    period: 'Q4 2027',
    status: 'planned',
    description: '',
    deliverables: [],
    media: [],
  },
];

export const currentStage = projectStages.find((stage) => stage.status === 'active') ?? projectStages[0];
